import React, { useState, useEffect, useRef } from 'react';
import {
  Row,
  Input,
  Card,
  CardBody,
  Label,
  Col,
  InputGroup,
  Button,
} from 'reactstrap';
import { Switch, FormControlLabel } from '@material-ui/core';
import { DataTable, Column } from 'vivace-fluent-motion';
import SelectComponent from '@componentes/select/select.component';
import { useDispatch, useSelector } from 'react-redux';
import * as organizarActions from '../store/organizar.action';
import * as commonActions from '@common/common.action';
import { quadroKanbanEnum } from '@common/util/defaultValues';
import DragDropApi from '../../dragdrop.api';
import ModalLocalizacao from '../../../../pages/arquivamento/tabs/Arquivamento/modais/Localizacao';

import IntlMessage from "../../../../helpers/intlMessage";
import { useIntl } from 'react-intl';

export default function Arquivamento(props) {
  const [destino, setDestino] = useState([]);
  const [destinos, setDestinos] = useState([]);
  const [selectGrid, setSelectGrid] = useState(0);
  const [identificacao, setIdentificacao] = useState();
  const [isAutoInput, setIsAutoInput] = useState(false);
  const [isRequisicaoMaterial, setIsRequisicaoMaterial] = useState(false);
  const dispatch = useDispatch();
  const [showModalLocalizacao, setShowModalLocalizacao] = useState(false);
  const [localizacaoArquivamento, setLocalizacaoArquivamento] = useState('');

  const intl = useIntl()

  const componentRef = useRef();
  const organizarLote = useSelector(state => state.organizarLote);

  useEffect(() => {
    const data = props.data[Object.keys(props.data)[0]];
    if (data && data.length > 0) {
      reset();
      insertSelect(data);
    }
  }, [props.data]);

  useEffect(() => {
    clearList();
  }, [])

  useEffect(() => {
    const disabled = !selectGrid || destino.length === 0;
    dispatch(organizarActions.atualizarMoverDisabled(disabled));
  }, [selectGrid, destino]);

  useEffect(() => {
    dispatch(organizarActions.atualizarModal(true));
    /// Só vou exibir o modal caso o destino seja,
    if (destino.label === 'Solicitados' || isRequisicaoMaterial) {
      if (props.click) moverItens();
    } else {
      if (props.click) {
        setShowModalLocalizacao(true);
      }
    }
    props.onClick();
  }, [props.click]);

  useEffect(() => {
    function montarColunas(list) {
      let colunas = [];
      // eslint-disable-next-line array-callback-return
      list.map((item) => {
        colunas.push({
          label: item.title.text,
          value: Object.keys(item)[0],
        });
      });
      props.lista.length > 0 && setDestinos(colunas);
    }

    setIsRequisicaoMaterial(
      Object.entries(props.lista[1])[1][1].text === 'Concluídos'
    );
    montarColunas(props.lista);
  }, [props.lista]);

  function clearList() {
    dispatch(organizarActions.atualizarLista([]));
  }

  function reset() {
    dispatch(organizarActions.atualizarLamina([]));
    dispatch(organizarActions.atualizarMoverDisabled(true));
    // setLista([]);
    dispatch(organizarActions.atualizarLista([]));
    setSelectGrid(0);
    setDestino([]);
  }

  function selectItem(e) {
    let tr = document.getElementsByTagName('tr');
    let checkboxes = document
      .getElementsByClassName('kanban-arquivamento-organizar-table')[0]
      .querySelectorAll('input[name=checkbox]:checked');
    setSelectGrid(checkboxes.length);
    let items = document
      .getElementsByClassName('kanban-arquivamento-organizar-table')[0]
      .getElementsByTagName('tr').length;
    if (checkboxes.length < items - 1) {
      document.getElementById('selectMaterias').checked = false;
    } else {
      document.getElementById('selectMaterias').checked = true;
    }
    for (let i = 0; i < tr.length - 1; i++) {
      if (
        document.getElementsByTagName('tr')[i + 1].getElementsByTagName('td')
          .length > 0 &&
        document
          .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
          .getElementsByTagName('input')[0]
      ) {
        if (
          document
            .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
            .getElementsByTagName('input')[1].id === e.target.id
        ) {
          if (
            document
              .getElementsByTagName('tr')[i + 1].getAttribute('datacheck') === 'true'
          ) {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'false');
          } else {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'true');
          }
        }
      }
    }
  }

  function onChangeSelect(e) {
    let tr = document.getElementsByTagName('tr');
    for (let i = 0; i < tr.length - 1; i++) {
      if (
        document.getElementsByTagName('tr')[i + 1].getElementsByTagName('td')
          .length > 0 &&
        document
          .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
          .getElementsByTagName('input')[0]
      ) {
        if (
          document
            .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
            .getElementsByTagName('input')[1].id === e.data.itemId.toString()
        ) {
          if (
            document
              .getElementsByTagName('tr')[i + 1].getAttribute('datacheck') === 'true'
          ) {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'false');
            document.getElementById(e.data.itemId.toString()).checked = false;
          } else {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'true');
            document.getElementById(e.data.itemId.toString()).checked = true;
          }
        }
      }
    }
    let checkboxes = document
      .getElementsByClassName('kanban-arquivamento-organizar-table')[0]
      .querySelectorAll('input[name=checkbox]:checked');
    setSelectGrid(checkboxes.length);
    let items = document
      .getElementsByClassName('kanban-arquivamento-organizar-table')[0]
      .getElementsByTagName('tr').length;
    if (checkboxes.length < items - 1) {
      document.getElementById('selectMaterias').checked = false;
    } else {
      document.getElementById('selectMaterias').checked = true;
    }
  }

  function toggleCheckBox(checked) {
    let checkboxes = document
      .getElementsByClassName('kanban-arquivamento-organizar-table')[0]
      .getElementsByClassName('checkbox');
    for (let i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i] !== checked) {
        checkboxes[i].checked = checked;
        let doc = document
          .getElementsByClassName('kanban-arquivamento-organizar-table')[0]
          .getElementsByTagName('tr')[i + 1];
        if (checked) {
          setSelectGrid(checkboxes.length);
          doc && doc.setAttribute('datacheck', 'true');
        } else {
          setSelectGrid(0);
          doc && doc.setAttribute('datacheck', 'false');
        }
      }
    }
  }

  function changeAutoInput(e) {
    setIsAutoInput(e);
    setTimeout(() => {
      componentRef.current.focus();
    }, 600);
    setIdentificacao('');
  }

  function removerItem(id) {
    let draft = organizarLote.lista;
    let index = draft.findIndex((x) => x.id === id);
    draft.splice(index, 1);
    // setLista(draft);
    dispatch(organizarActions.atualizarLista(draft));
  }

  function insertSelect(dados) {
    const novaLista = organizarLote.lista;

    if (isRequisicaoMaterial) {
      let novoItem = {
        itemId: dados.idRequisicao,
        identificacao: dados.numero,
        material: dados.material,
        tecnico: dados.requisitante,
        remove: (
          <Button onClick={() => removerItem(dados.idLamina)}>
            <i className="mv-basico-apagar"></i>
          </Button>
        ),
        select: (
          <input
            className="checkbox"
            name="checkbox"
            type="checkbox"
            id={`lamina_${dados.idRequisicao}`}
            onClick={(e) => selectItem(e)}
          />
        ),
      };

      let itemJaIncluido = novaLista.map(
        (item) => novoItem.itemId === item.itemId && true
      );

      if (itemJaIncluido.indexOf(true) >= 0) {
        dispatch(
          commonActions.showAlerta(
            'alerta',
            'Esse item já foi adicionado',
            3000
          )
        );
      } else {
        novaLista.push(novoItem);
        // setLista(novaLista);
        dispatch(organizarActions.atualizarLista(novaLista));
      }
    } else {
      let novoItem = {
        itemId: dados.laudoArquivosId,
        identificacao: dados.numeroMaterial,
        material: dados.descricaoMaterial,
        tecnico: dados.nomeTecnico,
        remove: (
          <Button onClick={() => removerItem(dados.idLamina)}>
            <i className="mv-basico-apagar"></i>
          </Button>
        ),
        select: (
          <input
            className="checkbox"
            name="checkbox"
            type="checkbox"
            id={`lamina_${dados.laudoArquivosId}`}
            onClick={(e) => selectItem(e)}
          />
        ),
      };

      let itemJaIncluido = novaLista.map(
        (item) => novoItem.itemId === item.itemId && true
      );

      if (itemJaIncluido.indexOf(true) >= 0) {
        dispatch(
          commonActions.showAlerta(
            'alerta',
            'Esse item já foi adicionado',
            3000
          )
        );
      } else {
        novaLista.push(novoItem);
        // setLista(novaLista);
        dispatch(organizarActions.atualizarLista(novaLista));
      }
    }

    dispatch(commonActions.showFadeCarregando(false));
  }

  function getIconeStatus(value) {
    let icone, status;

    if (
      Object.keys(props.lista[0])[0] === quadroKanbanEnum.AM_SOLICITADOS.id &&
      value === quadroKanbanEnum.AM_ARQUIVADOS.id
    ) {
      status = quadroKanbanEnum.AM_ARQUIVADOS.status;
    }

    return { icone, status };
  }

  function montarPayload(itens, destination) {
    if (isRequisicaoMaterial) {
      let requisicoes = [];
      for (let item of itens) {
        let requisicao = item.id.split('_');

        const iconeStatus = getIconeStatus(destination);
        requisicoes.push({
          IdRequisicao: +requisicao[1],
          status: iconeStatus.status,
        });
      }
      return requisicoes;
    } else {
      let arquivamentos = [];
      for (let item of itens) {
        let arquivamento = item.id.split('_');
        const iconeStatus = getIconeStatus(destination);
        arquivamentos.push({
          arquivamentoId: +arquivamento[1],
          localizacao: localizacaoArquivamento,
          status: iconeStatus.status,
        });
      }
      return arquivamentos;
    }
  }

  function adicionarItem() {
    if (!identificacao) return;

    dispatch(commonActions.showFadeCarregando(true));

    //Requisição de materiais
    if (isRequisicaoMaterial) {
      DragDropApi.getRequisicao(identificacao).then((res) => {
        insertSelect(res.data);
      });
      setIdentificacao('');
    } else {
      //Arquivamento
      DragDropApi.getArquivamento(identificacao).then((res) => {
        insertSelect(res.data);
      });
      setIdentificacao('');
    }
  }

  function changeIdentificacao(e) {
    let cdBloco = e;
    if (isAutoInput) {
      if (cdBloco && cdBloco.length > 3) {
        dispatch(commonActions.showFadeCarregando(true));
        if (isRequisicaoMaterial) {
          DragDropApi.getRequisicao(cdBloco).then((res) => {
            insertSelect(res.data);
          });
        } else {
          DragDropApi.getArquivamento(cdBloco).then((res) => {
            insertSelect(res.data);
          });
        }
      } else
        cdBloco && cdBloco.length > 3
          ? setIdentificacao('')
          : setIdentificacao(cdBloco);
      componentRef.current.focus();
    } else {
      setIdentificacao(cdBloco);
    }
  }

  async function moverItens() {
    dispatch(commonActions.showFadeCarregando(true));
    const data = document
      .getElementsByClassName('kanban-arquivamento-organizar-table')[0]
      .querySelectorAll('input[name=checkbox]:checked');
    // const id = Object.keys(props.data)[0];
    // const source = {
    //   droppableId: id,
    //   index: props.lista.findIndex((x) => Object.keys(x)[0] === id),
    //   ...getIconeStatus(id),
    // };

    // const destination = {
    //   droppableId: destino.value,
    //   index: props.lista.findIndex((x) => Object.keys(x)[0] === destino.value),
    //   ...getIconeStatus(destino.value),
    // };

    /// Tomada de decisão para identificar entre arquivamento e requisição de materiais.
    ///Requisição de material
    if (isRequisicaoMaterial) {
      const payload = montarPayload(data, destino.value);
      const request = { requisicoes: payload };
      const sendRequisicao = await DragDropApi.requisicaoMateriais(request);
      if (sendRequisicao.success) {
        dispatch(commonActions.showFadeCarregando(false));
        this.props.commonActions.showAlerta(
          'sucesso',
          `${intl.formatMessage({id:"dashboards.sample.itemsMovedSuccessfully"}) }`,
          1500
        );
        document.getElementById('btnPesquisar').click();
      } else {
      }
    } else {
      // Arquivamento
      const payload = montarPayload(data, destino.value);
      const arquivamentos = { arquivamentos: payload };
      const sendArquivamentos = await DragDropApi.arquivarMaterias(
        arquivamentos
      );
      if (sendArquivamentos.success) {
        dispatch(commonActions.showFadeCarregando(false));
        document.getElementById('btnPesquisar').click();
      }
    }
    setShowModalLocalizacao(false);
    return dispatch(organizarActions.atualizarModal(false));
  }

  return (
    <div>
      <ModalLocalizacao
        {...props}
        onModal={() => setShowModalLocalizacao(!showModalLocalizacao)}
        localizacaoArquivamento={localizacaoArquivamento}
        setLocalizacaoArquivamento={setLocalizacaoArquivamento}
        showModalLocalizacao={showModalLocalizacao}
        salvarLocalizacao={moverItens}
      />
      <Card>
        <CardBody>
          <Row>
            <Col sm={'auto'} style={{ marginRight: 0 }}>
              <InputGroup>
                <Input
                  innerRef={componentRef}
                  style={{ borderRadius: '5px', fontSize: '13px' }}
                  value={identificacao}
                  placeholder={`${intl.formatMessage({ id: 'dashboards.cytology.identificationNumber' })}`}
                  onChange={(e) => changeIdentificacao(e.target.value)}
                />
                <Button
                  className="btn btn-primary"
                  style={{ height: '38px', float: 'left' }}
                  disabled={isAutoInput}
                  onClick={() => adicionarItem()}
                >
                  <i className="icons-btn mv-basico-adicionar"></i>
                </Button>
              </InputGroup>
            </Col>
            <div className="col-4">
              <Label className="label-data col-auto" style={{ float: 'left' }}>
                {`${intl.formatMessage({ id: "dashboards.cytology.destiny" })}`}
              </Label>
              <SelectComponent
                onChange={(e) => setDestino(e)}
                className="col-auto"
                value={destino}
                options={destinos}
                placeholder={`${intl.formatMessage({ id: "dashboards.cytology.selectDestiny" })}`}
              />
            </div>
            <Col>
              <FormControlLabel
                control={
                  <Switch
                    checked={isAutoInput}
                    onChange={(e) => changeAutoInput(e.target.checked)}
                    name="descarte-imprimir"
                    color="primary"
                  />
                }
                label={<IntlMessage id="dashboards.histology.autoInput" />}
              />
            </Col>
          </Row>
          <br />
          <DataTable
            className="kanban-arquivamento-organizar-table"
            onContextMenu={(e) => onChangeSelect(e)}
            value={organizarLote.lista}
            //pageLinkSize={20}
            responsive={true}
            selectionMode="single"
            style={{ height: '100%' }}
            columnResizeMode="expand"
            scrollable={true}
            //scrollHeight="50vh"
            scrollWidth="100%"
            //resizableColumns={listaDetalhes.length >= 1}
            //reorderableColumns={listaDetalhes.length >= 1}
            //rowsPerPageOptions={[10, 20, 50]}
            //rows={totalItensPage}
            lazy={true}
            paginator={false}
            //loading={carregando}
            //loadingIcon="mv-basico-menu_secundario"
            emptyMessage={<IntlMessage id="dashboards.reports.noResultsFound" />}
            alwaysShowPaginator={false}
            autoLayout={true}
          //footer={<RenderizarFooter total={totalItens} />}
          >
            <Column
              sortable={false}
              field="select"
              style={{ width: '25px', verticalAlign: 'middle' }}
              header={
                organizarLote.lista.length >= 1 && (
                  <input
                    type="checkbox"
                    id="selectMaterias"
                    name="selectMaterias"
                    onChange={(e) => {
                      toggleCheckBox(e.target.checked);
                    }}
                  />
                )
              }
            />

            <Column
              sortable={false}
              field="identificacao"
              style={{
                width: '150px',
                verticalAlign: 'middle',
              }}
              header={`${intl.formatMessage({ id: "general.materialArchiving.identification" })}`}
            />

            <Column
              sortable={false}
              field="material"
              style={{ width: '150px', verticalAlign: 'middle' }}
              header={`${intl.formatMessage({id: 'general.materialArchiving.material'})}`}
            />

            <Column
              sortable={false}
              field="tecnico"
              style={{ width: '180px', verticalAlign: 'middle' }}
              header={<IntlMessage id="dashboards.sample.technicianName" />}
            />

            <Column
              style={{ width: 'auto', verticalAlign: 'middle' }}
              sortable={false}
              field="remove"
              header={<IntlMessage id = "general.materialArchiving.remove"/>}
            />
          </DataTable>
        </CardBody>
      </Card>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/componentes/dragdrog/organizarLote/containers/arquivamento.js